import moment from 'moment-timezone'
import { KC } from '@/http/utils'
import { Schema, SchemaSettings } from '@orbit/data'
import { ShiftAndRoundReportMetricDetails } from '@/jsonapi/CommonTypes'

enum ModelTypes {
  ShiftReport = 'shift-report',
}

enum ModelTypeNames {
  ShiftReport = 'shiftReport',
}

interface ShiftReportRoomDetails {
  roomNumber: string
  label: string | null
  values: ShiftAndRoundReportMetricDetails[] | null
}

interface ShiftReportEvents {
  name: string
  rooms: ShiftReportRoomDetails[]
}

export interface ShiftReportAttributes {
  resourceId: string
  resultStartTimestamp: number
  resultEndTimestamp: number
  starttimestamp: number
  endtimestamp: number
  risks: ShiftReportEvents[]
  incidents: ShiftReportEvents[]
  pids: string[]
}

export interface ShiftReportSchema {
  id: string
  attributes: ShiftReportAttributes
}

const schemaDefinition: SchemaSettings = {
  models: {
    [ModelTypeNames.ShiftReport]: {
      attributes: {
        resourceId: { type: 'string' },
        resultStartTimestamp: { type: 'number' },
        resultEndTimestamp: { type: 'number' },
        starttimestamp: { type: 'number' },
        endtimestamp: { type: 'number' },
        risks: { type: 'array' },
        incidents: { type: 'array' },
        pids: { type: 'array' },
      },
    },
  },
}

export async function getShiftReportQueryByTimestamps(params: { starttimestamp: number; endtimestamp: number }) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote
    .query(q => {
      console.log(
        `before calling find record for shift report [${moment(params.starttimestamp).format(
          'YYYY-MM-DD - HH:mm'
        )}] - [${moment(params.endtimestamp).format('YYYY-MM-DD - HH:mm')}]`
      )
      return q
        .findRecords(ModelTypes.ShiftReport)
        .filter(
          { attribute: 'starttimestamp', value: params.starttimestamp },
          { attribute: 'endtimestamp', value: params.endtimestamp }
        )
    })
    .catch(e => {
      console.log('fetch failed for shift report')
      console.log(e)
    })
}
